var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRestorePrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17592 2.68272C6.53535 3.10205 6.48678 3.73335 6.06746 4.09277L3.9707 5.89L6.12377 8.04307C6.5143 8.4336 6.5143 9.06676 6.12377 9.45729C5.73325 9.84781 5.10009 9.84781 4.70956 9.45729L1.79289 6.54062C1.59593 6.34366 1.49005 6.07348 1.50074 5.79514C1.51143 5.5168 1.63772 5.25553 1.84921 5.07426L4.76588 2.57426C5.1852 2.21484 5.8165 2.2634 6.17592 2.68272Z",
    fill: "#774EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 5.8335C1.5 5.28121 1.94772 4.8335 2.5 4.8335H12.0808C15.4858 4.8335 18.3625 7.59944 18.4951 11.0029C18.6356 14.6006 15.6774 17.6668 12.0808 17.6668H4.99917C4.44688 17.6668 3.99917 17.2191 3.99917 16.6668C3.99917 16.1145 4.44688 15.6668 4.99917 15.6668H12.0808C14.5451 15.6668 16.5927 13.5414 16.4966 11.0809L16.4966 11.0808C16.4058 8.75089 14.4117 6.8335 12.0808 6.8335H2.5C1.94772 6.8335 1.5 6.38578 1.5 5.8335Z",
    fill: "#774EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRestorePrimary);
export default __webpack_public_path__ + "static/media/arrow_restore_primary.dfc34cc160a523deae5062ac52852e74.svg";
export { ForwardRef as ReactComponent };